const TarifGrid = [
    { minDays: 1, maxDays: 10, price: 7584 },
    { minDays: 11, maxDays: 16, price: 10340 },
    { minDays: 17, maxDays: 24, price: 14476 },
    { minDays: 25, maxDays: 35, price: 17234 },
    { minDays: 36, maxDays: 62, price: 19301 },
    { minDays: 63, maxDays: 92, price: 22059 },
    { minDays: 93, maxDays: 123, price: 26195 },
    { minDays: 124, maxDays: 153, price: 30331 },
    { minDays: 154, maxDays: 180, price: 34467 }
];

export default TarifGrid;
